import React, { useState } from "react";
import "./App.css";
import "./DatePicker.css";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import {
  Login,
  ConfirmPhoneNumber,
  Dashboard,
  Menu,
  Orders,
  ManageCustomer,
  ChangeFactor,
  Support,
  SupportNewMessage,
  SupportScore,
  QrCode,
  QrCodeToWallet,
  QrCodeWithFactor,
  FactureList,
} from "./Pages/Index";
import { ToastContainer } from "react-toastify";
import DiscountOfOneCategory from "./Pages/DiscountOfOneCategory/DiscountOfOneCategory";

import Repoarts from "./Pages/Repoarts/Repoarts";
import AddMenuSupplier from "./Pages/AddMenuSupplier/AddMenuSupplier";

import AllProductDiscount from "./Pages/AllProductDiscount/AllProductDiscount";
import DiscountOneProduct from "./Pages/DiscountOneProduct/DiscountOneProduct";
import ManageComments from "./Pages/ManageComments/ManageComments";
import EditProductSupperMarket from "./Pages/EditProductSupperMarket/EditProductSupperMarket";
import EditDetailProduct from "./Pages/edit&detailProduct/EditDetailProduct";
import AddingProduct from "./Pages/AddingProduct/AddingProduct";
import AddProductResturant from "./Pages/AddProductRestaurant/AddProductRestaurant";
import Supplier from "./Pages/Supplier/Supplier";
import Acounting from "./Pages/Acounting/Acounting";
import { getTokens } from "./firebase";
import SupermarketProductContainer from "./Components/Temporary/SupermarketProduct/SupermarketProduct";
import AddBrandSupermarket from "./Components/Temporary/AddBrandSupermarket/AddBrandSupermarket";
import SelectAddress from "./Pages/SelectAddress/SelectAddress";
import ChooseFoodCategory from "./Pages/ChooseFoodCategory/ChooseFoodCategory";
import LiveLocation from "./Pages/LiveLocation/LiveLocation";
import RequestForSupplier from "./Pages/RequestForSupplier/RequestForSupplier";
import ManageDiscount from "./Pages/ManageDiscount/ManageDiscount";
import Profile from "./Pages/Profile/Profile";
import SupportChat from "./Pages/Support/SupportChat/SupportChat";

function App() {
  const [isTokenFound, setTokenFound] = useState(false);
  if (!!localStorage.getItem("JwtTokens")) {
    if (!isTokenFound) {
      getTokens(setTokenFound);
    }
  }
  const isLogin = () => !!localStorage.getItem("JwtTokens");
  const PublicRoute = ({ component, ...props }) => {
    return (
      <Route
        {...props}
        render={(props) => {
          if (isLogin()) return <Redirect to="/" />;
          else {
            return React.createElement(component);
          }
        }}
      />
    );
  };
  const PrivatRoute = ({ render, ...props }) => {
    return (
      <Route
        {...props}
        render={(props) => {
          if (isLogin()) return render(props);
          else {
            return <Redirect to="/login" />;
          }
        }}
      />
    );
  };
  return (
    <Router>
      <Switch>
        <PublicRoute exact path="/login" component={Login} />
        <PublicRoute
          exact
          path="/requestforsupplier"
          component={RequestForSupplier}
        />
        <Route exact path="/confirm" component={ConfirmPhoneNumber} />
        {/* <Route exact path='/loginas' component={Dashboard}/> */}
        <PrivatRoute
          path="/"
          render={() => (
            <Switch>
              <Route exact path="/" component={Dashboard} />
              <Route exact path="/menu" component={Menu} />
              <Route exact path="/orders" component={Orders} />
              <Route exact path="/allproduct" component={AllProductDiscount} />
              <Route exact path="/repoarts" component={Repoarts} />
              <Route exact path="/addmenu" component={AddMenuSupplier} />
              <Route exact path="/category" component={DiscountOfOneCategory} />
              <Route exact path="/oneproduct" component={DiscountOneProduct} />
              <Route
                exact
                path="/editeproductsuppermarket/:id"
                component={EditProductSupperMarket}
              />
              <Route exact path="/selectaddress" component={SelectAddress} />
              <Route
                exact
                path="/addproductsupermarket"
                component={SupermarketProductContainer}
              />
              <Route
                exact
                path="/addbrandsupermarket"
                component={AddBrandSupermarket}
              />
              <Route exact path={"/comments"} component={ManageComments} />
              <Route
                exact
                path={"/managediscount"}
                component={ManageDiscount}
              />
              <Route
                exact
                path={"/managecustomer"}
                component={ManageCustomer}
              />
              <Route exact path={"/profile"} component={Profile} />
              <Route exact path={"/changefactor"} component={ChangeFactor} />
              <Route
                exact
                path={"/editdetailproduct/:id"}
                component={EditDetailProduct}
              />
              <Route exact path={"/addproduct"} component={AddingProduct} />
              <Route
                exact
                path={"/addproductrestaurant"}
                component={AddProductResturant}
              />
              <Route exact path={"/supplier"} component={Supplier} />
              <Route exact path={"/support"} component={Support} />
              <Route exact path="/newmessage" component={SupportNewMessage} />
              <Route exact path="/supportchat/:id" component={SupportChat} />
              <Route exact path="/supportscore/:id" component={SupportScore} />
              <Route exact path={"/accounting"} component={Acounting} />
              <Route exact path={"/live"} component={LiveLocation} />
              <Route exact path={"/qrcode"} component={QrCode} />
              <Route exact path={"/facturelist"} component={FactureList} />
              <Route exact path={"/qrcode-wallet/:id"} component={QrCodeToWallet} />
              <Route exact path={"/qrcode-facture/:id"} component={QrCodeWithFactor} />
              <Route
                exact
                path={"/choosecategory"}
                component={ChooseFoodCategory}
              />
            </Switch>
          )}
        />
      </Switch>
      <ToastContainer limit={3} autoClose={2000} />
    </Router>
  );
}
export default App;
